import { Skeleton } from "@mui/material"

export const AvatarSkeleton = (props: AvatarSkeletonProps) => {
    const { size = 40 } = props
    
    return <Skeleton variant="circular" width={size} height={size}/>
}

type AvatarSkeletonProps = {
    size?: number,
} 